/** Ce mois / plage — calendrier FacturX, aligné aux boutons. */
import { FxDate } from "../../components/FxDate";
import { formatDay } from "../../formats/display";
import { monthStartIso, todayIso } from "../dashboard/period";

type Mode = "month" | "custom";

type PeriodBarProps = {
  mode: Mode;
  from: string;
  to: string;
  onMode: (mode: Mode) => void;
  onFrom: (v: string) => void;
  onTo: (v: string) => void;
};

export function PeriodBar({ mode, from, to, onMode, onFrom, onTo }: PeriodBarProps) {
  return (
    <div className="fx-report-period">
      <div className="fx-encaiss__modes" role="group" aria-label="Période">
        <button type="button" className={mode === "month" ? "is-on" : ""} onClick={() => onMode("month")}>
          Ce mois
        </button>
        <button type="button" className={mode === "custom" ? "is-on" : ""} onClick={() => onMode("custom")}>
          Dates
        </button>
      </div>
      {mode === "custom" ? (
        <div className="fx-report-period__dates">
          <label className="fx-report-period__lab">
            <span>Du</span>
            <FxDate value={from} onChange={onFrom} />
          </label>
          <label className="fx-report-period__lab">
            <span>Au</span>
            <FxDate value={to || todayIso()} onChange={onTo} />
          </label>
        </div>
      ) : (
        <p className="fx-report-period__hint">
          {formatDay(monthStartIso())} → {formatDay(todayIso())}
        </p>
      )}
    </div>
  );
}
